// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.App {
  text-align: center;
}

.App-logo {
  height: 40vmin;
  pointer-events: none;
}

@media (prefers-reduced-motion: no-preference) {
  .App-logo {
    animation: App-logo-spin infinite 20s linear;
  }
}

.homebackground {
  background-color: #5c9cdc;
}

.App-header {
  background-color: #282c34;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: calc(10px + 2vmin);
  color: white;
}

.confirmpaybutton {
  background-color: yellow;
  color: #282c34;
  border-width: 10;
  border-color: #29008a;
  border: 2px solid black;
  border-radius: 12px;
}

.App-link {
  color: #61dafb;
}

@keyframes App-logo-spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
/* Small devices (Phones, 600pxand down) -- this would display the text at 5.0rem on phones */
@media only screen and (max-width: 600px) {
  html {
    font-size: 13px;
  }
}

/* Large devices (laptops/desktops, 992px and up) -- This would display the text at 10.0rem on laptops and larger screens */
@media only screen and (min-width: 992px) {
  html {
    font-size: 13px;
  }
}

.buttonhover:hover {
  background-color: blue;
  padding-top: 2px;
  padding-right: 2px;
  padding-left: 2px;
  padding-bottom: 2px;
}

.mysplitbutton {
  background-color: lightblue;
  color: darkblue;
  padding: 2px;
  font-size: 20px !important;
  border: none;
  cursor: pointer;
  min-width: 100%;
  text-align: left;
}

.card-img-top {
  width: 100%;
  height: 120px;
  object-fit: contain;
}

.cardprodimg-on-cartview {
  width: 75%;
  height: 60px;
  object-fit: contain;
}
.productimg-on-productlist {
  width: 100%;
  height: 60px;
  object-fit: contain;
}

.prd-img {
  width: 50px;
  height: 50px;
  object-fit: contain;
}

.carouselimg {
  width: 100%;
  height: 300px;
  /* object-fit: contain; */
}

.cartviewtable {
  /* font-family: Verdana, Geneva, Tahoma, sans-serif; */
  font-size: 11px !important;
  font-weight: normal;
}

.cartviewtableOnCheckout {
  /* font-family: Verdana, Geneva, Tahoma, sans-serif; */
  font-size: 12px !important;
}

.incdectable {
  /* margin: auto; */
  width: 100% !important;
  padding: 0px;
}

.searchboxchanges {
  /* margin: auto; */
  /* width: 100% !important; */
  /* padding: 0px; */
  font-size: 18px;
  height: 30px;
  text-align: left;
}

div.noPadding {
  padding-left: 0;
  padding-right: 0;
}

div.noMargin {
  margin-left: 0;
  margin-right: 0;
}
div.fullwidth {
  width: 100%;
}
table.fullwidth {
  width: 100%;
}

nav a:hover {
  /* border-top: 4px solid white;
  border-bottom: 4px solid white; */
  background: black;

  padding: 6px 0;
}

.panel-body {
  height: 430px;
  width: 100%;
  overflow: hidden;
  /* transform: rotate(90deg); */
  /* transform-origin: 188px 241px 0; */
}
.t1 {
  max-height: 390px;
  overflow: scroll;
}
.t2 {
  height: 320px;
  width: 720px;
}

.testimonial-group > .row {
  display: block;
  overflow-x: auto;
  white-space: nowrap;
}
.testimonial-group > .row > .col-4 {
  display: inline-block;
}
.col-4 {
  color: blue;
  font-size: 14px;
  padding-bottom: 20px;
  padding-top: 18px;
  padding-top: 18px;
  width: 220px;
}

.accordion-button:not(.collapsed) {
  /*color: #ffffff;
   background-color: #29008a; */
  /* color: #ffffff;
  background-color: deepskyblue; */
  color: #282c34;
  background-color: white;
  box-shadow: inset 0 -1px 0 rgb(0 0 0 / 13%);
}

.table100width {
  width: 100%;
}

.trhead {
  background-color: lightcyan;
  font-size: 14px;
}
.trheight {
  line-height: 35px;
  font-size: 12px;
}

.removemarginpadding {
  margin: 0;
  padding: 0;
}

.whitespacewrap {
  white-space: nowrap;
}

.cartcustom {
  stop-color: blueviolet;
  color: blueviolet;
  flood-color: blueviolet;
  background-color: yellow;
  border: #29008a;
  border-color: #29008a;
  border-bottom: 1px solid #61dafb;
  border-top: 1px solid #61dafb;
  border-left: 1px solid #61dafb;
  border-right: 1px solid #61dafb;

  margin: 3px;
}
.tablenopadding {
  padding: 0 !important;
}
.cartcustom:hover {
  color: white !important;
  background-color: yellowgreen;
  border-color: yellow; /*set the color you want here*/
}

.accordionheadertitle {
  /* font-family: Arial, Helvetica, sans-serif; */
  font-size: 26px;
}

.offcanvas-top.h-auto {
  bottom: initial;
}

.orderpage2background {
  background-color: aliceblue;
}

.blink_me {
  animation: blinker 1s linear infinite;
}

@keyframes blinker {
  50% {
    opacity: 0;
  }
}

.productpage {
  background-color: #5c9cdc;
}

.mainnavbar {
  font-family: Arial, Helvetica, sans-serif;
}

.mainthemecolor {
  /* background-color: midnightblue; */
  background-color: black;
  color: white !important;
}
.secondarythemeColorCode {
  background-color: royalblue;
  color: white;
  font-weight: bold;
}
.secondarythemecolor {
  /* background-color: darkgrey; */
  background-color: lightgray;
  color: black;
  font-weight: bold;
}
.pagebackground {
  /* background-color: lightgray; */
  background-color: white;
}

.navbarmycustomcolor {
  color: #ffffff;
  background-color: #29008a;
  font-size: 14px;
}
/* .navbar-brand {
  color: green !important;
  font-size: 1.5rem;
} */
.navbar-custom {
  background-color: darkblue !important;
  color: blue !important;
  font-size: 1rem;
}
.navbar-topnav {
  background-color: blueviolet;
}

.anyVerticalScroll {
  height: 800px;
  overflow-y: scroll;
}

.verticalaligncentertd {
  display: flex;
  vertical-align: middle;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}

.navBarLink {
  /* margin: 3px; */
  /* position: absolute; */
  color: white !important;
  padding: 1px;
  font-weight: bold;
  font-size: small;
}
.navBarLink:hover {
  color: white !important;
  background-color: darkslateblue;
  color: white;
  padding: 1px;
  border-color: yellow; /*set the color you want here*/
}

.adminstorename {
  color: yellow;
  font-family: "Courier New", Courier, monospace;
}

.completeorderbtn {
  background-color: yellow;
}
.completeorderbtn:hover {
  background-color: yellowgreen;
}
.paymentcontainercustom {
  background-color: white;
  border: 1px solid burlywood;
  /* font-family: "Gill Sans", "Gill Sans MT", Calibri, "Trebuchet MS", sans-serif,
    "Gill Sans MT", Calibri, "Trebuchet MS", sans-serif; */
}
/* it's required since after  razorpay window close, screen vertical scroll freeze  */
body {
  overflow: visible !important;
}

.checkoutform {
  background-color: whitesmoke;
  /* border: 2px solid black; */
}

body {
  /* font-family: "Poppins", sans-serif; */
  font-family: Roboto, Helvetica, sans-serif;
}

.offcanvasmenucustom {
  width: 15%;
}

.inlinecontrol {
  float: left;
  margin-right: 5px;
}

.instockqtyrequiredwidth {
  width: 20% !important;
}

.orderrow:hover {
  background-color: deepskyblue;
}

.signincustom {
  width: "20px";
}

.widthcss {
  width: 70% !important;
}

.fullHeightDiv {
  position: absolute;
  height: 100%;
  bottom: 0;
}

.menubutton:focus {
  outline: 0;
  border: white;
  border-color: white;
  border-bottom: 3px solid white;
  border-top: 3px solid white;
  border-left: 3px solid white;
  border-right: 3px solid white;
}

.aligncenerintd {
  display: flex;
  justify-content: center;
  align-items: center;
}
.aligncenerintd1 {
  display: flex;
  justify-content: center;
  align-items: center;
}

.msgboxlabel {
  white-space: pre-wrap;
}

.scrollTable {
  height: 500px;
  overflow: auto; /* Hide the horizontal scroll */
}
.fixedTableHight {
  display: block;
  width: 100%;
  height: 350px;
  overflow-y: scroll;
  overflow: auto;
  /* position: absolute; */
}
.fixedTableHightForProductGroup {
  display: block;
  width: 100%;
  height: 480px;
  overflow-y: scroll;
  /* position: absolute; */
}
.fixedTableHightForEmployeeTimesheet {
  display: block;
  width: 100%;
  height: 800px;
  overflow-y: scroll;
  /* position: absolute; */
}

.ordertablecustom {
  /* font-family: Arial, Helvetica, sans-serif; */
  font-size: 12px !important;
  font-weight: normal;
}

.notify-badge-right1 {
  position: relative;
  right: 0px;
  top: -5px;
  background: white;
  text-align: center;
  border-radius: 30px 30px 30px 30px;
  color: red;
  padding: 5px 8px;
  font-size: 10px;
}

.notify-badge-quote {
  position: relative;
  right: 0px;
  top: -35px;
  background: white;
  text-align: center;
  /* border-radius: 30px 30px 30px 30px; */
  color: red;
  padding: 5px 8px;
  font-size: 10px;
}

.orderStatusFontsize {
  font-size: 16px !important;
}

.order-summary-mobile {
  width: 97vw; /* Occupy the 90% of the screen width */
  max-width: 97vw;
}
.order-modal-mobile {
  width: 98vw; /* Occupy the 90% of the screen width */
  max-width: 100vw;
  /* overflow-x: auto; */

  /* max-height: 98vh;
  overflow-y: auto; */

  /* position: absolute;
  top: 0%;
  left: 2%; */
}

.purchaserequest-modal {
  width: 85vw; /* Occupy the 90% of the screen width */
  max-width: 90vw;
  overflow-x: auto;
  max-height: "80%";
  overflow-y: auto;
}

.productservice-modal {
  width: 98vw; /* Occupy the 90% of the screen width */
  max-width: 98vw;
  overflow-x: auto;
}

.order-modal {
  width: 85vw; /* Occupy the 90% of the screen width */
  max-width: 90vw;
  overflow-x: auto;
}
.purchaseorder-modal {
  width: 85vw; /* Occupy the 90% of the screen width */
  max-width: 90vw;
  max-height: "80%";
  overflow-x: auto;
  overflow-y: auto;
}

.modal-body-order-detail {
  max-width: 100%;
  overflow-x: auto;
}

.list-group-order-detail {
  width: 600px;
  /* float: left; */
  /* margin-left: 10px; */
}
.costfont {
  font-family: Arial, Helvetica, sans-serif;
  font-size: 16px !important;
}

.invertimage {
  filter: invert(100%);
}
.notify-badge-HomeFrontMenu {
  position: absolute;
  right: 0px;
  top: 5px;
  /* background: white; */
  text-align: center;
  border-radius: 50px 50px 50px 50px;
  /* color: red; */
  padding: 8px 10px;
  font-size: 12px;
}

.fixedTableHightOrder {
  display: block;
  width: 100%;
  height: 200px;
  overflow-y: scroll;
  overflow: auto;
  /* position: absolute; */
}

.TopCornerRounded {
  border-radius: 30px 30px 0px 00px;
  padding-left: 1px;
  padding-right: 1px;
}
.CornersRounded {
  border-radius: 30px 30px 30px 30px;
  padding-left: 1px;
  padding-right: 1px;
}
.CornersRoundedSmall {
  border-radius: 10px 10px 10px 10px;
  padding-left: 1px;
  padding-right: 1px;
}
.CornersRoundedMedium {
  border-radius: 20px 20px 20px 20px;
  padding-left: 1px;
  padding-right: 1px;
}
.CornersRoundedBig {
  border-radius: 50px 50px 50px 50px;
  padding-left: 1px;
  padding-right: 1px;
}

.buttonRounded {
  border-radius: 20px 20px 20px 20px;
  padding-left: 20px;
  padding-right: 20px;
}

.loadspinnermodalalign {
  /* width: 100%;
  display: flex; */
  justify-content: center;
  align-items: center;
}
.logohover:hover {
  background-color: transparent !important;
  color: white;

  /* padding-top: 1px;
  padding-right: 1px;
  padding-left: 1px;
  padding-bottom: 1px; */
}

.spinnermodalcenter {
  display: flex !important;
  width: 100% !important;
  pointer-events: none;
  justify-content: center;
  align-items: center;
}
.spinnermodal-backdrop {
  -webkit-backdrop-filter: blur(0.2px);
          backdrop-filter: blur(0.2px);
  background-color: #01223770;
}
.logoback {
  /* background-color: transparent !important; */
  background-color: rgb(0, 0, 0, 0.8);
  color: white;

  /* padding-top: 1px;
  padding-right: 1px;
  padding-left: 1px;
  padding-bottom: 1px; */
}

.posbutton {
  background: red;
  border: 0;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0;
}

.posbutton::after {
  content: "";
  display: block;
  padding-bottom: 100%;
}

@media print {
  body {
    visibility: hidden;
  }
  #divcontents {
    visibility: visible;
    position: absolute;
    left: 0;
    top: 0;
  }
}

.graphscontainer {
  display: flex; /* Makes the container a flex container */
  flex-direction: row; /* Arranges items horizontally (default, but good to be explicit) */
  justify-content: around; /* Aligns items in the center of the main axis */
  /* Other values: flex-start, flex-end, space-between, space-around, space-evenly */
  height: 200px; /* Example height for visualization */
}

/* .accordion-button {
  color: #ffffff;
  background-color: black;
  box-shadow: inset 0 -1px 0 rgb(0 0 0 / 13%);
}

.accordion-button:not(.collapsed) {
  color: #ffffff;
  background-color: #29008a;
  box-shadow: inset 0 -1px 0 rgb(0 0 0 / 13%);
} */
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE;IACE,4CAA4C;EAC9C;AACF;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;EAC7B,YAAY;AACd;;AAEA;EACE,wBAAwB;EACxB,cAAc;EACd,gBAAgB;EAChB,qBAAqB;EACrB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;AACA,6FAA6F;AAC7F;EACE;IACE,eAAe;EACjB;AACF;;AAEA,2HAA2H;AAC3H;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;EAC3B,eAAe;EACf,YAAY;EACZ,0BAA0B;EAC1B,YAAY;EACZ,eAAe;EACf,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,sDAAsD;EACtD,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,sDAAsD;EACtD,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,4BAA4B;EAC5B,kBAAkB;EAClB,eAAe;EACf,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;AACA;EACE,WAAW;AACb;AACA;EACE,WAAW;AACb;;AAEA;EACE;mCACiC;EACjC,iBAAiB;;EAEjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,gBAAgB;EAChB,8BAA8B;EAC9B,qCAAqC;AACvC;AACA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,YAAY;AACd;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,WAAW;EACX,eAAe;EACf,oBAAoB;EACpB,iBAAiB;EACjB,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE;+BAC6B;EAC7B;kCACgC;EAChC,cAAc;EACd,uBAAuB;EACvB,2CAA2C;AAC7C;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,2BAA2B;EAC3B,eAAe;AACjB;AACA;EACE,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,iBAAiB;EACjB,uBAAuB;EACvB,wBAAwB;EACxB,eAAe;EACf,qBAAqB;EACrB,gCAAgC;EAChC,6BAA6B;EAC7B,8BAA8B;EAC9B,+BAA+B;;EAE/B,WAAW;AACb;AACA;EACE,qBAAqB;AACvB;AACA;EACE,uBAAuB;EACvB,6BAA6B;EAC7B,oBAAoB,EAAE,8BAA8B;AACtD;;AAEA;EACE,+CAA+C;EAC/C,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE;IACE,UAAU;EACZ;AACF;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,oCAAoC;EACpC,uBAAuB;EACvB,uBAAuB;AACzB;AACA;EACE,2BAA2B;EAC3B,YAAY;EACZ,iBAAiB;AACnB;AACA;EACE,gCAAgC;EAChC,2BAA2B;EAC3B,YAAY;EACZ,iBAAiB;AACnB;AACA;EACE,iCAAiC;EACjC,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,eAAe;AACjB;AACA;;;GAGG;AACH;EACE,qCAAqC;EACrC,sBAAsB;EACtB,eAAe;AACjB;AACA;EACE,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,wBAAwB;EACxB,uBAAuB;EACvB,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,uBAAuB;EACvB,+BAA+B;EAC/B,YAAY;EACZ,YAAY;EACZ,oBAAoB,EAAE,8BAA8B;AACtD;;AAEA;EACE,aAAa;EACb,8CAA8C;AAChD;;AAEA;EACE,wBAAwB;AAC1B;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,uBAAuB;EACvB,2BAA2B;EAC3B;0DACwD;AAC1D;AACA,qFAAqF;AACrF;EACE,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;EAC5B,6BAA6B;AAC/B;;AAEA;EACE,wCAAwC;EACxC,0CAA0C;AAC5C;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,SAAS;AACX;;AAEA;EACE,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,2BAA2B;EAC3B,4BAA4B;EAC5B,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,cAAc,EAAE,+BAA+B;AACjD;AACA;EACE,cAAc;EACd,WAAW;EACX,aAAa;EACb,kBAAkB;EAClB,cAAc;EACd,wBAAwB;AAC1B;AACA;EACE,cAAc;EACd,WAAW;EACX,aAAa;EACb,kBAAkB;EAClB,wBAAwB;AAC1B;AACA;EACE,cAAc;EACd,WAAW;EACX,aAAa;EACb,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA;EACE,+CAA+C;EAC/C,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,iBAAiB;EACjB,kBAAkB;EAClB,kCAAkC;EAClC,UAAU;EACV,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,UAAU;EACV,iBAAiB;EACjB,kBAAkB;EAClB,wCAAwC;EACxC,UAAU;EACV,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,WAAW,EAAE,uCAAuC;EACpD,eAAe;AACjB;AACA;EACE,WAAW,EAAE,uCAAuC;EACpD,gBAAgB;EAChB,sBAAsB;;EAEtB;qBACmB;;EAEnB;;aAEW;AACb;;AAEA;EACE,WAAW,EAAE,uCAAuC;EACpD,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,WAAW,EAAE,uCAAuC;EACpD,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW,EAAE,uCAAuC;EACpD,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,WAAW,EAAE,uCAAuC;EACpD,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,uBAAuB;AACzB;AACA;EACE,yCAAyC;EACzC,0BAA0B;AAC5B;;AAEA;EACE,oBAAoB;AACtB;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,uBAAuB;EACvB,kBAAkB;EAClB,kCAAkC;EAClC,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,aAAa;EACb,kBAAkB;EAClB,cAAc;EACd,wBAAwB;AAC1B;;AAEA;EACE,iCAAiC;EACjC,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,kCAAkC;EAClC,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,kCAAkC;EAClC,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,kCAAkC;EAClC,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,kCAAkC;EAClC,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,kCAAkC;EAClC,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE;kBACgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,wCAAwC;EACxC,YAAY;;EAEZ;;;wBAGsB;AACxB;;AAEA;EACE,wBAAwB;EACxB,sBAAsB;EACtB,oBAAoB;EACpB,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,oCAA4B;UAA5B,4BAA4B;EAC5B,2BAA2B;AAC7B;AACA;EACE,8CAA8C;EAC9C,mCAAmC;EACnC,YAAY;;EAEZ;;;wBAGsB;AACxB;;AAEA;EACE,eAAe;EACf,SAAS;EACT,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;IACnB,kBAAkB;IAClB,OAAO;IACP,MAAM;EACR;AACF;;AAEA;EACE,aAAa,EAAE,yCAAyC;EACxD,mBAAmB,EAAE,mEAAmE;EACxF,uBAAuB,EAAE,gDAAgD;EACzE,kFAAkF;EAClF,aAAa,EAAE,qCAAqC;AACtD;;AAEA;;;;;;;;;;GAUG","sourcesContent":[".App {\r\n  text-align: center;\r\n}\r\n\r\n.App-logo {\r\n  height: 40vmin;\r\n  pointer-events: none;\r\n}\r\n\r\n@media (prefers-reduced-motion: no-preference) {\r\n  .App-logo {\r\n    animation: App-logo-spin infinite 20s linear;\r\n  }\r\n}\r\n\r\n.homebackground {\r\n  background-color: #5c9cdc;\r\n}\r\n\r\n.App-header {\r\n  background-color: #282c34;\r\n  min-height: 100vh;\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  justify-content: center;\r\n  font-size: calc(10px + 2vmin);\r\n  color: white;\r\n}\r\n\r\n.confirmpaybutton {\r\n  background-color: yellow;\r\n  color: #282c34;\r\n  border-width: 10;\r\n  border-color: #29008a;\r\n  border: 2px solid black;\r\n  border-radius: 12px;\r\n}\r\n\r\n.App-link {\r\n  color: #61dafb;\r\n}\r\n\r\n@keyframes App-logo-spin {\r\n  from {\r\n    transform: rotate(0deg);\r\n  }\r\n  to {\r\n    transform: rotate(360deg);\r\n  }\r\n}\r\n/* Small devices (Phones, 600pxand down) -- this would display the text at 5.0rem on phones */\r\n@media only screen and (max-width: 600px) {\r\n  html {\r\n    font-size: 13px;\r\n  }\r\n}\r\n\r\n/* Large devices (laptops/desktops, 992px and up) -- This would display the text at 10.0rem on laptops and larger screens */\r\n@media only screen and (min-width: 992px) {\r\n  html {\r\n    font-size: 13px;\r\n  }\r\n}\r\n\r\n.buttonhover:hover {\r\n  background-color: blue;\r\n  padding-top: 2px;\r\n  padding-right: 2px;\r\n  padding-left: 2px;\r\n  padding-bottom: 2px;\r\n}\r\n\r\n.mysplitbutton {\r\n  background-color: lightblue;\r\n  color: darkblue;\r\n  padding: 2px;\r\n  font-size: 20px !important;\r\n  border: none;\r\n  cursor: pointer;\r\n  min-width: 100%;\r\n  text-align: left;\r\n}\r\n\r\n.card-img-top {\r\n  width: 100%;\r\n  height: 120px;\r\n  object-fit: contain;\r\n}\r\n\r\n.cardprodimg-on-cartview {\r\n  width: 75%;\r\n  height: 60px;\r\n  object-fit: contain;\r\n}\r\n.productimg-on-productlist {\r\n  width: 100%;\r\n  height: 60px;\r\n  object-fit: contain;\r\n}\r\n\r\n.prd-img {\r\n  width: 50px;\r\n  height: 50px;\r\n  object-fit: contain;\r\n}\r\n\r\n.carouselimg {\r\n  width: 100%;\r\n  height: 300px;\r\n  /* object-fit: contain; */\r\n}\r\n\r\n.cartviewtable {\r\n  /* font-family: Verdana, Geneva, Tahoma, sans-serif; */\r\n  font-size: 11px !important;\r\n  font-weight: normal;\r\n}\r\n\r\n.cartviewtableOnCheckout {\r\n  /* font-family: Verdana, Geneva, Tahoma, sans-serif; */\r\n  font-size: 12px !important;\r\n}\r\n\r\n.incdectable {\r\n  /* margin: auto; */\r\n  width: 100% !important;\r\n  padding: 0px;\r\n}\r\n\r\n.searchboxchanges {\r\n  /* margin: auto; */\r\n  /* width: 100% !important; */\r\n  /* padding: 0px; */\r\n  font-size: 18px;\r\n  height: 30px;\r\n  text-align: left;\r\n}\r\n\r\ndiv.noPadding {\r\n  padding-left: 0;\r\n  padding-right: 0;\r\n}\r\n\r\ndiv.noMargin {\r\n  margin-left: 0;\r\n  margin-right: 0;\r\n}\r\ndiv.fullwidth {\r\n  width: 100%;\r\n}\r\ntable.fullwidth {\r\n  width: 100%;\r\n}\r\n\r\nnav a:hover {\r\n  /* border-top: 4px solid white;\r\n  border-bottom: 4px solid white; */\r\n  background: black;\r\n\r\n  padding: 6px 0;\r\n}\r\n\r\n.panel-body {\r\n  height: 430px;\r\n  width: 100%;\r\n  overflow: hidden;\r\n  /* transform: rotate(90deg); */\r\n  /* transform-origin: 188px 241px 0; */\r\n}\r\n.t1 {\r\n  max-height: 390px;\r\n  overflow: scroll;\r\n}\r\n.t2 {\r\n  height: 320px;\r\n  width: 720px;\r\n}\r\n\r\n.testimonial-group > .row {\r\n  display: block;\r\n  overflow-x: auto;\r\n  white-space: nowrap;\r\n}\r\n.testimonial-group > .row > .col-4 {\r\n  display: inline-block;\r\n}\r\n.col-4 {\r\n  color: blue;\r\n  font-size: 14px;\r\n  padding-bottom: 20px;\r\n  padding-top: 18px;\r\n  padding-top: 18px;\r\n  width: 220px;\r\n}\r\n\r\n.accordion-button:not(.collapsed) {\r\n  /*color: #ffffff;\r\n   background-color: #29008a; */\r\n  /* color: #ffffff;\r\n  background-color: deepskyblue; */\r\n  color: #282c34;\r\n  background-color: white;\r\n  box-shadow: inset 0 -1px 0 rgb(0 0 0 / 13%);\r\n}\r\n\r\n.table100width {\r\n  width: 100%;\r\n}\r\n\r\n.trhead {\r\n  background-color: lightcyan;\r\n  font-size: 14px;\r\n}\r\n.trheight {\r\n  line-height: 35px;\r\n  font-size: 12px;\r\n}\r\n\r\n.removemarginpadding {\r\n  margin: 0;\r\n  padding: 0;\r\n}\r\n\r\n.whitespacewrap {\r\n  white-space: nowrap;\r\n}\r\n\r\n.cartcustom {\r\n  stop-color: blueviolet;\r\n  color: blueviolet;\r\n  flood-color: blueviolet;\r\n  background-color: yellow;\r\n  border: #29008a;\r\n  border-color: #29008a;\r\n  border-bottom: 1px solid #61dafb;\r\n  border-top: 1px solid #61dafb;\r\n  border-left: 1px solid #61dafb;\r\n  border-right: 1px solid #61dafb;\r\n\r\n  margin: 3px;\r\n}\r\n.tablenopadding {\r\n  padding: 0 !important;\r\n}\r\n.cartcustom:hover {\r\n  color: white !important;\r\n  background-color: yellowgreen;\r\n  border-color: yellow; /*set the color you want here*/\r\n}\r\n\r\n.accordionheadertitle {\r\n  /* font-family: Arial, Helvetica, sans-serif; */\r\n  font-size: 26px;\r\n}\r\n\r\n.offcanvas-top.h-auto {\r\n  bottom: initial;\r\n}\r\n\r\n.orderpage2background {\r\n  background-color: aliceblue;\r\n}\r\n\r\n.blink_me {\r\n  animation: blinker 1s linear infinite;\r\n}\r\n\r\n@keyframes blinker {\r\n  50% {\r\n    opacity: 0;\r\n  }\r\n}\r\n\r\n.productpage {\r\n  background-color: #5c9cdc;\r\n}\r\n\r\n.mainnavbar {\r\n  font-family: Arial, Helvetica, sans-serif;\r\n}\r\n\r\n.mainthemecolor {\r\n  /* background-color: midnightblue; */\r\n  background-color: black;\r\n  color: white !important;\r\n}\r\n.secondarythemeColorCode {\r\n  background-color: royalblue;\r\n  color: white;\r\n  font-weight: bold;\r\n}\r\n.secondarythemecolor {\r\n  /* background-color: darkgrey; */\r\n  background-color: lightgray;\r\n  color: black;\r\n  font-weight: bold;\r\n}\r\n.pagebackground {\r\n  /* background-color: lightgray; */\r\n  background-color: white;\r\n}\r\n\r\n.navbarmycustomcolor {\r\n  color: #ffffff;\r\n  background-color: #29008a;\r\n  font-size: 14px;\r\n}\r\n/* .navbar-brand {\r\n  color: green !important;\r\n  font-size: 1.5rem;\r\n} */\r\n.navbar-custom {\r\n  background-color: darkblue !important;\r\n  color: blue !important;\r\n  font-size: 1rem;\r\n}\r\n.navbar-topnav {\r\n  background-color: blueviolet;\r\n}\r\n\r\n.anyVerticalScroll {\r\n  height: 800px;\r\n  overflow-y: scroll;\r\n}\r\n\r\n.verticalaligncentertd {\r\n  display: flex;\r\n  vertical-align: middle;\r\n  align-items: center;\r\n  justify-content: center;\r\n  z-index: 9999;\r\n}\r\n\r\n.navBarLink {\r\n  /* margin: 3px; */\r\n  /* position: absolute; */\r\n  color: white !important;\r\n  padding: 1px;\r\n  font-weight: bold;\r\n  font-size: small;\r\n}\r\n.navBarLink:hover {\r\n  color: white !important;\r\n  background-color: darkslateblue;\r\n  color: white;\r\n  padding: 1px;\r\n  border-color: yellow; /*set the color you want here*/\r\n}\r\n\r\n.adminstorename {\r\n  color: yellow;\r\n  font-family: \"Courier New\", Courier, monospace;\r\n}\r\n\r\n.completeorderbtn {\r\n  background-color: yellow;\r\n}\r\n.completeorderbtn:hover {\r\n  background-color: yellowgreen;\r\n}\r\n.paymentcontainercustom {\r\n  background-color: white;\r\n  border: 1px solid burlywood;\r\n  /* font-family: \"Gill Sans\", \"Gill Sans MT\", Calibri, \"Trebuchet MS\", sans-serif,\r\n    \"Gill Sans MT\", Calibri, \"Trebuchet MS\", sans-serif; */\r\n}\r\n/* it's required since after  razorpay window close, screen vertical scroll freeze  */\r\nbody {\r\n  overflow: visible !important;\r\n}\r\n\r\n.checkoutform {\r\n  background-color: whitesmoke;\r\n  /* border: 2px solid black; */\r\n}\r\n\r\nbody {\r\n  /* font-family: \"Poppins\", sans-serif; */\r\n  font-family: Roboto, Helvetica, sans-serif;\r\n}\r\n\r\n.offcanvasmenucustom {\r\n  width: 15%;\r\n}\r\n\r\n.inlinecontrol {\r\n  float: left;\r\n  margin-right: 5px;\r\n}\r\n\r\n.instockqtyrequiredwidth {\r\n  width: 20% !important;\r\n}\r\n\r\n.orderrow:hover {\r\n  background-color: deepskyblue;\r\n}\r\n\r\n.signincustom {\r\n  width: \"20px\";\r\n}\r\n\r\n.widthcss {\r\n  width: 70% !important;\r\n}\r\n\r\n.fullHeightDiv {\r\n  position: absolute;\r\n  height: 100%;\r\n  bottom: 0;\r\n}\r\n\r\n.menubutton:focus {\r\n  outline: 0;\r\n  border: white;\r\n  border-color: white;\r\n  border-bottom: 3px solid white;\r\n  border-top: 3px solid white;\r\n  border-left: 3px solid white;\r\n  border-right: 3px solid white;\r\n}\r\n\r\n.aligncenerintd {\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n}\r\n.aligncenerintd1 {\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n}\r\n\r\n.msgboxlabel {\r\n  white-space: pre-wrap;\r\n}\r\n\r\n.scrollTable {\r\n  height: 500px;\r\n  overflow: auto; /* Hide the horizontal scroll */\r\n}\r\n.fixedTableHight {\r\n  display: block;\r\n  width: 100%;\r\n  height: 350px;\r\n  overflow-y: scroll;\r\n  overflow: auto;\r\n  /* position: absolute; */\r\n}\r\n.fixedTableHightForProductGroup {\r\n  display: block;\r\n  width: 100%;\r\n  height: 480px;\r\n  overflow-y: scroll;\r\n  /* position: absolute; */\r\n}\r\n.fixedTableHightForEmployeeTimesheet {\r\n  display: block;\r\n  width: 100%;\r\n  height: 800px;\r\n  overflow-y: scroll;\r\n  /* position: absolute; */\r\n}\r\n\r\n.ordertablecustom {\r\n  /* font-family: Arial, Helvetica, sans-serif; */\r\n  font-size: 12px !important;\r\n  font-weight: normal;\r\n}\r\n\r\n.notify-badge-right1 {\r\n  position: relative;\r\n  right: 0px;\r\n  top: -5px;\r\n  background: white;\r\n  text-align: center;\r\n  border-radius: 30px 30px 30px 30px;\r\n  color: red;\r\n  padding: 5px 8px;\r\n  font-size: 10px;\r\n}\r\n\r\n.notify-badge-quote {\r\n  position: relative;\r\n  right: 0px;\r\n  top: -35px;\r\n  background: white;\r\n  text-align: center;\r\n  /* border-radius: 30px 30px 30px 30px; */\r\n  color: red;\r\n  padding: 5px 8px;\r\n  font-size: 10px;\r\n}\r\n\r\n.orderStatusFontsize {\r\n  font-size: 16px !important;\r\n}\r\n\r\n.order-summary-mobile {\r\n  width: 97vw; /* Occupy the 90% of the screen width */\r\n  max-width: 97vw;\r\n}\r\n.order-modal-mobile {\r\n  width: 98vw; /* Occupy the 90% of the screen width */\r\n  max-width: 100vw;\r\n  /* overflow-x: auto; */\r\n\r\n  /* max-height: 98vh;\r\n  overflow-y: auto; */\r\n\r\n  /* position: absolute;\r\n  top: 0%;\r\n  left: 2%; */\r\n}\r\n\r\n.purchaserequest-modal {\r\n  width: 85vw; /* Occupy the 90% of the screen width */\r\n  max-width: 90vw;\r\n  overflow-x: auto;\r\n  max-height: \"80%\";\r\n  overflow-y: auto;\r\n}\r\n\r\n.productservice-modal {\r\n  width: 98vw; /* Occupy the 90% of the screen width */\r\n  max-width: 98vw;\r\n  overflow-x: auto;\r\n}\r\n\r\n.order-modal {\r\n  width: 85vw; /* Occupy the 90% of the screen width */\r\n  max-width: 90vw;\r\n  overflow-x: auto;\r\n}\r\n.purchaseorder-modal {\r\n  width: 85vw; /* Occupy the 90% of the screen width */\r\n  max-width: 90vw;\r\n  max-height: \"80%\";\r\n  overflow-x: auto;\r\n  overflow-y: auto;\r\n}\r\n\r\n.modal-body-order-detail {\r\n  max-width: 100%;\r\n  overflow-x: auto;\r\n}\r\n\r\n.list-group-order-detail {\r\n  width: 600px;\r\n  /* float: left; */\r\n  /* margin-left: 10px; */\r\n}\r\n.costfont {\r\n  font-family: Arial, Helvetica, sans-serif;\r\n  font-size: 16px !important;\r\n}\r\n\r\n.invertimage {\r\n  filter: invert(100%);\r\n}\r\n.notify-badge-HomeFrontMenu {\r\n  position: absolute;\r\n  right: 0px;\r\n  top: 5px;\r\n  /* background: white; */\r\n  text-align: center;\r\n  border-radius: 50px 50px 50px 50px;\r\n  /* color: red; */\r\n  padding: 8px 10px;\r\n  font-size: 12px;\r\n}\r\n\r\n.fixedTableHightOrder {\r\n  display: block;\r\n  width: 100%;\r\n  height: 200px;\r\n  overflow-y: scroll;\r\n  overflow: auto;\r\n  /* position: absolute; */\r\n}\r\n\r\n.TopCornerRounded {\r\n  border-radius: 30px 30px 0px 00px;\r\n  padding-left: 1px;\r\n  padding-right: 1px;\r\n}\r\n.CornersRounded {\r\n  border-radius: 30px 30px 30px 30px;\r\n  padding-left: 1px;\r\n  padding-right: 1px;\r\n}\r\n.CornersRoundedSmall {\r\n  border-radius: 10px 10px 10px 10px;\r\n  padding-left: 1px;\r\n  padding-right: 1px;\r\n}\r\n.CornersRoundedMedium {\r\n  border-radius: 20px 20px 20px 20px;\r\n  padding-left: 1px;\r\n  padding-right: 1px;\r\n}\r\n.CornersRoundedBig {\r\n  border-radius: 50px 50px 50px 50px;\r\n  padding-left: 1px;\r\n  padding-right: 1px;\r\n}\r\n\r\n.buttonRounded {\r\n  border-radius: 20px 20px 20px 20px;\r\n  padding-left: 20px;\r\n  padding-right: 20px;\r\n}\r\n\r\n.loadspinnermodalalign {\r\n  /* width: 100%;\r\n  display: flex; */\r\n  justify-content: center;\r\n  align-items: center;\r\n}\r\n.logohover:hover {\r\n  background-color: transparent !important;\r\n  color: white;\r\n\r\n  /* padding-top: 1px;\r\n  padding-right: 1px;\r\n  padding-left: 1px;\r\n  padding-bottom: 1px; */\r\n}\r\n\r\n.spinnermodalcenter {\r\n  display: flex !important;\r\n  width: 100% !important;\r\n  pointer-events: none;\r\n  justify-content: center;\r\n  align-items: center;\r\n}\r\n.spinnermodal-backdrop {\r\n  backdrop-filter: blur(0.2px);\r\n  background-color: #01223770;\r\n}\r\n.logoback {\r\n  /* background-color: transparent !important; */\r\n  background-color: rgb(0, 0, 0, 0.8);\r\n  color: white;\r\n\r\n  /* padding-top: 1px;\r\n  padding-right: 1px;\r\n  padding-left: 1px;\r\n  padding-bottom: 1px; */\r\n}\r\n\r\n.posbutton {\r\n  background: red;\r\n  border: 0;\r\n  border-radius: 50%;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  padding: 0;\r\n}\r\n\r\n.posbutton::after {\r\n  content: \"\";\r\n  display: block;\r\n  padding-bottom: 100%;\r\n}\r\n\r\n@media print {\r\n  body {\r\n    visibility: hidden;\r\n  }\r\n  #divcontents {\r\n    visibility: visible;\r\n    position: absolute;\r\n    left: 0;\r\n    top: 0;\r\n  }\r\n}\r\n\r\n.graphscontainer {\r\n  display: flex; /* Makes the container a flex container */\r\n  flex-direction: row; /* Arranges items horizontally (default, but good to be explicit) */\r\n  justify-content: around; /* Aligns items in the center of the main axis */\r\n  /* Other values: flex-start, flex-end, space-between, space-around, space-evenly */\r\n  height: 200px; /* Example height for visualization */\r\n}\r\n\r\n/* .accordion-button {\r\n  color: #ffffff;\r\n  background-color: black;\r\n  box-shadow: inset 0 -1px 0 rgb(0 0 0 / 13%);\r\n}\r\n\r\n.accordion-button:not(.collapsed) {\r\n  color: #ffffff;\r\n  background-color: #29008a;\r\n  box-shadow: inset 0 -1px 0 rgb(0 0 0 / 13%);\r\n} */\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
